import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Util from "../../../Util";
import { useTranslation } from "react-i18next";
import Sort from "../../../assets/Icon/Short.png";
import moment from "moment/moment";
import TagButton from "../TagButton";
import {
  browneTagStyle,
  greenTagStyle,
  orangeTagStyle,
  redTagStyle,
} from "../TagButtonStyle";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ApiCalling from "../../../network/ApiCalling";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Select from "react-dropdown-select";
import { DateRangePicker } from "rsuite";
import { InvoiceStatus } from "../../../Enums";
import { imageStudentList, invoiceDownload } from "../../CommonImage";
import InvoiceView from "../../ParentsDashboard/Billing/InvoiceView";
import Loader from "../../../components/common/Loader";
import { Avatar } from "@mui/material";
import * as XLSX from "xlsx/xlsx.mjs";
import ToastHOC from "../../HOC/ToastHOC";

function AllSchoolInvoices({ message }) {
  const { t } = useTranslation();
  const history = useHistory();
  const school = Util.getSelectedSchool();
  const schoolId = school?.id;

  const [isLoading, setIsLoading] = useState(false);
  const [allInvoices, setAllInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(8);
  const [feeTypeList, setFeeTypeList] = useState([]);
  const [feeTypeId, setFeeTypeId] = useState(0);
  const [search, setSearch] = useState("");
  const [searchClick, setSearchClick] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isVisibleInvoice, setIsVisibleInvoice] = useState(false);
  const [invoiceId, setInvoiceId] = useState(0);
  const [studentId, setStudentId] = useState(0);
  const [studentName, setStudentName] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [sortdata, setsortdata] = useState(false);
  const [termList, setTermList] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const [stageList, setStageList] = useState([]);
  const [level, setLevel] = useState(0);
  const [grade, setGrade] = useState(0);
  const [term, setTerm] = useState(0);
  const [billingPlanList, setBillingPlanList] = useState([]);
  const [billingPlanId, setBillingPlanId] = useState(0);

  const getFeeTypeList = () => {
    ApiCalling.apiCallBodyDataGet("fee-types/list")
      .then((res) => {
        setFeeTypeList(res.data || []);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const changeFeeTypes = (data) => {
    setCurrentPage(1);
    setFeeTypeId(data[0].id);
  };

  const ChangeDateRange = (range) => {
    if (range) {
      setStartDate(new Date(range[0]));
      setEndDate(new Date(range[1]));
    }
  };

  const changeStage = (data) => {
    setLevel(data[0].id);
  };

  const changeGrade = (data) => {
    setGrade(data[0].id);
  };

  const changeTerm = (data) => {
    setTerm(data[0].id);
  };

  const ChangePlan = (data) => {
    setBillingPlanId(data[0].id);
  };

  const handleCleanDate = () => {
    setStartDate();
    setEndDate();
  };

  const searchClicked = () => {
    setCurrentPage(1);
    setSearchClick(search);
  };
  const EnterHandler = (event) => {
    if (event.key === "Enter") {
      setSearchClick(search);
    }
  };

  const handlePreviousClick = () => {
    if (currentPage !== 1) {
      setCurrentPage((currentPage) => currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage !== totalPages) {
      setCurrentPage((currentPage) => currentPage + 1);
    }
  };

  const DownloadInvoice = (id) => {
    ApiCalling.apiCallBodyDataGet(`billing-invoice/download-mail/${id}`)
      .then((res) => {
        if (res.data.status == true) {
          window.open(res.data.invoice, "_blank");
        } else {
          message(res.data.message);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const sendReminder = (id) => {
    ApiCalling.apiCallBodyDataGet(`billing-invoice/send-mail/${id}`)
      .then((res) => {
        if (res.data.status == true) {
          message(res.data.message);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const handleSort = (field) => {
    setSortBy(field);
    setSortOrder(!sortOrder);
  };

  const getTermsList = async () => {
    setIsLoading(true);
    ApiCalling.apiCallParamsGet("terms/school").then((res) => {
      setIsLoading(false);
      setTermList(res.data);
    });
  };

  const getStageList = async () => {
    setIsLoading(true);
    ApiCalling.apiCallBodyDataGet("stage/list")
      .then((res) => {
        setIsLoading(false);
        setStageList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  
  const getGradeList = async () => {
    setIsLoading(true);
    ApiCalling.apiCallBodyDataGet("grade/list").then((res) => {
      setIsLoading(false);
      setGradeList(res.data);
    });
  };

  const getBillPlanList = () => {
    const data = {
      page_size: 10000,
      page_number: 1,
      stage_id: 0,
      grade_id: 0,
      terms_id: 0,
    };
    setIsLoading(true);
    ApiCalling.apiCallBodyDataPost("billing-plans/saved", data)
      .then((res) => {
        setIsLoading(false);
        setBillingPlanList(res.data.data || []);
        console.log(res.data.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const getAllInvoices = () => {
    setIsLoading(true);
    const data = {
      school_id: schoolId,
      page: currentPage,
      size: recordPerPage,
      student_name: searchClick,
      start_date: startDate,
      fee_type: feeTypeId,
      end_date: endDate,
      ascdesc: sortOrder ? "desc" : "asc",
      order_by: sortBy,
      level: level,
      grade: grade,
      term: term,
    };
    ApiCalling.apiCallBodyDataPost("billing-invoice/school", data)
      .then((res) => {
        if (res.data) {
          setIsLoading(false);
          setAllInvoices(res.data.response);
          setOriginalData(res.data.response);
          setTotalPages(res.data.total_page);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    getAllInvoices();
  }, [
    currentPage,
    recordPerPage,
    feeTypeId,
    searchClick,
    startDate,
    endDate,
    sortBy,
    sortOrder,
    level,
    grade,
    term,
    billingPlanId,
  ]);
  useEffect(() => {
    getFeeTypeList();
    getStageList();
    getGradeList();
    getTermsList();
    getBillPlanList();
  }, []);

  const handleSortFeeType = () => {
    setIsLoading(true);
    if (sortdata) {
      allInvoices.sort((a, b) =>
        a?.types[0]?.Fee_Type > b?.types[0]?.Fee_Type ? 1 : -1
      );
      setIsLoading(false);
      setAllInvoices(allInvoices);
    } else {
      allInvoices.sort((a, b) =>
        a?.types[0]?.Fee_Type > b?.types[0]?.Fee_Type ? -1 : 1
      );

      setIsLoading(false);
      setAllInvoices(allInvoices);
    }
    setsortdata(!sortdata);
  };

  const exportToExcel = () => {
    let exportdata;
    const data = {
      student_name: searchClick,
      start_date: startDate,
      fee_type: feeTypeId,
      end_date: endDate,
    };
    ApiCalling.apiCallBodyDataPost("billing-invoice", data)
      .then((res) => {
        exportdata = res.data;
        console.log(exportdata);
        if (exportdata.length > 0) {
          const dataForExport = exportdata.map((val) => ({
            Id: val?.Student?.id,
            StudentName:
              val?.Student?.first_name + "" + val?.Student?.last_name,
            Invoice: Util.invoiceIdFormat(val?.id),
            FeeType: val?.types.map((f) => f.Fee_Type).join(", "),
            Date: moment(val?.date).format(
              Util.getMomentDateTimeFormat(school.date_format)
            ),
            Status: Util.getInvoiceStatus(val?.status),
            Amount: Util.amountFormat(val?.total),
            Balance: Util.amountFormat(val?.due),
          }));
          const worksheet = XLSX.utils.json_to_sheet(dataForExport);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "student Age Report"
          );

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = URL.createObjectURL(blob);
          const newTab = window.open(url, "_blank");

          newTab.addEventListener("load", () => {
            URL.revokeObjectURL(url);
          });
        } else {
          message("No Data Available");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-end mb-3">
        <button
          className="btn btn-lg text-nowrap custom-primary m-1"
          type="button"
          onClick={exportToExcel}
        >
          {t("Export Excel")}
        </button>
      </div>
      <div className={"table-div"}>
        <div className="d-flex gap-20 align-items-center table-sort-bar justify-content-between">
          <div className="d-flex gap-20 align-items-center table-sort-bar">
            <div className="">
              <div className="input-group">
                <input
                  className="form-control search"
                  placeholder="Search Student"
                  type="text"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  onKeyPress={(e) => EnterHandler(e)}
                />
                <div className="input-group-prepend">
                  <div className="search-icon" onClick={searchClicked}>
                    <i className="fa fa-search"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="mr-2">
              <Select
                className="select-custom"
                options={[{ id: 0, type: "Fee Types" }, ...feeTypeList]}
                onChange={(values) => changeFeeTypes(values)}
                style={{ width: "100%" }}
                labelField="type"
                values={[{ id: 0, type: "Fee Types" }]}
                valueField="id"
                searchable={false}
              />
            </div>
            <div className="mr-2">
              <DateRangePicker
                onChange={(range) => ChangeDateRange(range)}
                onClean={handleCleanDate}
                placeholder="Select Date"
              />
            </div>
            <div className="mr-2">
              <Select
                searchable={false}
                className="select-custom text-nowrap"
                options={[{ id: 0, stage: "Level" }, ...stageList]}
                onChange={(values) => changeStage(values)}
                style={{ width: "100%" }}
                labelField="stage"
                values={[{ id: 0, stage: "Level" }]}
                valueField="id"
              />
            </div>

            <div className="mr-2">
              <Select
                searchable={false}
                className="select-custom text-nowrap"
                options={[{ id: 0, title: "Grade" }, ...gradeList]}
                onChange={(values) => changeGrade(values)}
                style={{ width: "100%" }}
                labelField="title"
                values={[{ id: 0, title: "Grade" }]}
                valueField="id"
              />
            </div>

            <div className="mr-2">
              <Select
                searchable={false}
                className="select-custom text-nowrap"
                options={[{ id: 0, title: "Terms" }, ...termList]}
                onChange={(values) => changeTerm(values)}
                style={{ width: "100%" }}
                labelField="title"
                values={[{ id: 0, title: "Terms" }]}
                valueField="id"
              />
            </div>

            <div className="mr-2">
              <Select
                searchable={false}
                className="select-custom text-nowrap"
                options={[{ id: 0, name: "Billing Plan" }, ...billingPlanList]}
                onChange={(values) => ChangePlan(values)}
                style={{ width: "100%" }}
                labelField="name"
                values={[{ id: 0, name: "Billing Plan" }]}
                valueField="id"
              />
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-12">
            <div className="table-wrapper">
              {!isLoading ? (
                <table
                  className="table"
                  style={{ border: "1px solid #e5e7eb", borderRadius: "12px" }}
                >
                  <thead style={{ backgroundColor: "#e5e7eb" }}>
                    <tr className="text-nowrap">
                      <th>
                        {t("Student Name")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("student.first_name");
                          }}
                        />
                      </th>
                      <th>
                        {t("Student ID")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("student.id");
                          }}
                        />
                      </th>

                      <th>
                        {t("Invoice")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("invoice.id");
                          }}
                        />
                      </th>
                      <th>
                        {t("Invoice Created On")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("invoice.created_on");
                          }}
                        />
                      </th>
                      <th>
                        {t("Fee Type")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSortFeeType();
                          }}
                        />
                      </th>
                      <th>
                        {t("Date")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("invoice.date");
                          }}
                        />
                      </th>
                      <th>
                        {t("Status")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("invoice.status");
                          }}
                        />
                      </th>
                      <th>
                        {t("Amount")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("invoice.total");
                          }}
                        />
                      </th>
                      <th>
                        {t("Balance")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("invoice.due");
                          }}
                        />
                      </th>
                      <th>
                        {t("Level")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("stage.id");
                          }}
                        />
                      </th>
                      <th>
                        {t("Grade")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("grades.id");
                          }}
                        />
                      </th>
                      <th>
                        {t("Term")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("term.id");
                          }}
                        />
                      </th>
                      <th>
                        {t("Count Of Days Per Week")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("billingPlan.count_of_days");
                          }}
                        />
                      </th>
                      <th>
                        {t("Billing Cycle")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("billingPlan.period");
                          }}
                        />
                      </th>
                      <th>
                        {t("Billing Plan")}{" "}
                        <img
                          src={Sort}
                          className="ml-1 fa-sort"
                          alt=""
                          onClick={() => {
                            handleSort("billingPlan.name");
                          }}
                        />
                      </th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  {allInvoices.length > 0 ? (
                    <tbody>
                      {allInvoices.map((a, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td
                                style={{
                                  paddingLeft: "0px",
                                  width: 0,
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  {a.Student?.photo ? (
                                    <img
                                      className="rounded-circle "
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                      }}
                                      src={a?.Student.photo}
                                      alt=""
                                    />
                                  ) : (
                                    <Avatar
                                      aria-label="recipe"
                                      className="avatar-font"
                                    >
                                      {a?.Student.first_name.toUpperCase()[0] +
                                        a?.Student.last_name.toUpperCase()[0]}
                                    </Avatar>
                                  )}
                                  <a
                                    className="ml-3"
                                    style={{ fontWeight: "600" }}
                                  >
                                    {a?.Student.first_name}{" "}
                                    {a?.Student.last_name}
                                  </a>
                                </div>
                              </td>
                              <td>{a?.Student?.id}</td>

                              <td> {Util.invoiceIdFormat(a.id)}</td>
                              <td>
                                {moment(a.created_on).format(
                                  Util.getMomentDateTimeFormat(
                                    school.date_format
                                  )
                                )}
                              </td>
                              <td>
                                {a.types.length > 0 ? (
                                  <p style={{ whiteSpace: "pre-line" }}>
                                    {Util.getListDisplay(
                                      a.types.map((f) => f.Fee_Type),
                                      2,
                                      "\n"
                                    )}
                                  </p>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                {moment(a.date).format(
                                  Util.getMomentDateTimeFormat(
                                    school.date_format
                                  )
                                )}
                              </td>
                              <td>
                                <TagButton
                                  style={"btn btn-secondary"}
                                  size={"150px"}
                                  title={Util.getInvoiceStatus(a.status)}
                                  buttonStyle={
                                    a.status == 0
                                      ? redTagStyle
                                      : a.status == 1
                                      ? orangeTagStyle
                                      : a.status == 3
                                      ? browneTagStyle
                                      : greenTagStyle
                                  }
                                  icon="fa fa-circle"
                                  iconSize="6px"
                                />
                              </td>
                              <td>{Util.amountFormat(a.total)}</td>
                              <td>{Util.invoiceFormat(a.due)}</td>
                              <td>
                                {a?.Billing_Plan?.Grade?.Stage?.stage
                                  ? a?.Billing_Plan?.Grade?.Stage?.stage
                                  : "-"}
                              </td>
                              <td>
                                {a?.Billing_Plan?.Grade?.title
                                  ? a?.Billing_Plan?.Grade?.title
                                  : "-"}
                              </td>
                              <td>
                                {a?.Billing_Plan?.Term?.title
                                  ? a?.Billing_Plan?.Term?.title
                                  : "-"}
                              </td>
                              <td>
                                {a?.Billing_Plan?.count_of_days
                                  ? a?.Billing_Plan?.count_of_days
                                  : "-"}
                              </td>
                              <td>
                                {a?.Billing_Plan?.period
                                  ? a?.Billing_Plan?.period
                                  : "-"}
                              </td>
                              <td>
                                {a?.Billing_Plan?.name
                                  ? a?.Billing_Plan?.name
                                  : "One Time Charge"}
                              </td>
                              <td>
                                <div className="dropdown">
                                  <button
                                    className="btn btn-lg custom-primary "
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{
                                      color: "#ffffff",
                                      padding: "5px, 10px",
                                    }}
                                  >
                                    {t("Action")}
                                  </button>
                                  <ul
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    <li style={{ cursor: "pointer" }}>
                                      <a
                                        className="dropdown-item"
                                        onClick={() => {
                                          setIsVisibleInvoice(true);
                                          setInvoiceId(a.id);
                                          setStudentId(a.student_id);
                                          setStudentName(
                                            a.Student.first_name +
                                              " " +
                                              a.Student.last_name
                                          );
                                        }}
                                      >
                                        {t("View")}
                                      </a>
                                      {(InvoiceStatus.PARTIAL_PAID ==
                                        a.status ||
                                        InvoiceStatus.UNPAID == a.status) && (
                                        <>
                                          <a
                                            className="dropdown-item"
                                            target="_blank"
                                            onClick={() => sendReminder(a.id)}
                                          >
                                            {t("Send Reminder")}
                                          </a>
                                        </>
                                      )}
                                      <a
                                        className="dropdown-item"
                                        onClick={() => {
                                          DownloadInvoice(a.id);
                                        }}
                                      >
                                        {t("Download")}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  ) : (
                    <tfoot>
                      <tr>
                        <td colSpan={8}>{t("Not Found!")}</td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              ) : (
                <Loader />
              )}
              <InvoiceView
                show={isVisibleInvoice}
                onClose={() => {
                  setIsVisibleInvoice(false);
                }}
                invoiceId={invoiceId}
              />
            </div>
            {totalPages > 0 && (
              <div className="row m-0 table-footer border-top mb-2 p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-2">
                    <div className="basic-text">{t("Invoices Per Page")}</div>
                    <div>
                      <select
                        name=""
                        id=""
                        className="select-dropdown custom-input"
                        value={recordPerPage}
                        onChange={(e) => {
                          setRecordPerPage(e.target.value);
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                  </div>
                  <Stack spacing={2} direction="row" alignItems="center">
                    <div
                      className={`link-button ${
                        currentPage == 1 ? "disabled" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePreviousClick();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <KeyboardArrowLeftIcon />
                      <span className="basic-bold-text">{t("Previous")}</span>
                    </div>
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={(event, page) => {
                        setCurrentPage(page);
                      }}
                      size="small"
                      hideNextButton
                      hidePrevButton
                    />
                    <div
                      className={`link-button ${
                        currentPage == totalPages ? "disabled" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNextClick();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <span className="basic-bold-text">{t("Next")}</span>
                      <KeyboardArrowRightIcon />
                    </div>
                  </Stack>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default ToastHOC(AllSchoolInvoices);
